// 이벤트 규칙 — 서버(_template/api/internal/events)와 같은 규칙을 보내기 전에 먼저 건다 (prd/103 FR-026)
// 서버가 최종 판정이고, 여기서 거르는 것은 개인정보가 네트워크에 실리기 전에 막으려는 것이다
export const EVENT_NAME_RE = /^[a-z][a-z0-9_]*\.[a-z][a-z0-9_]*$/;
export const MAX_PROPS_BYTES = 4 * 1024;

const PII_WORDS = new Set([
  'email', 'mail', 'phone', 'mobile', 'tel', 'telephone', 'address', 'addr', 'ssn', 'rrn', 'jumin',
  'password', 'passwd', 'pwd', 'card', 'iban', 'birth', 'birthday', 'dob', 'ip',
]);
// 값 전체가 이메일 꼴일 때만 — URL 안의 `/@user/` 같은 경로는 걸지 않는다
const EMAIL_VALUE_RE = /^[^\s@/:]+@[^\s@/:]+\.[^\s@/:]+$/;
const PHONE_VALUE_RE = /^(?:\+?\d{1,3}[\s-])?\(?0?\d{1,4}\)?[\s-]\d{3,4}[\s-]\d{4}$|^01[016789]\d{7,8}$/;

export type RuleViolation = 'name' | 'pii' | 'size';

/**
 * userEmail · user_email · user1Email · IPAddress 를 단어로 쪼갠다.
 * 경계: 구분자, 소문자·숫자 → 대문자, 대문자 연속 뒤 대문자+소문자(IPAddress → IP Address).
 * 서버(api/internal/events/event.go splitWords)와 같은 규칙 — contracts/event-rule-cases.json 이 둘을 같이 잰다
 */
export function splitWords(key: string): string[] {
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .map(w => w.toLowerCase());
}

/** 개인정보로 보이는 첫 경로를 돌려준다. 없으면 null */
export function findPii(value: unknown, path = ''): string | null {
  if (typeof value === 'string') {
    return EMAIL_VALUE_RE.test(value) || PHONE_VALUE_RE.test(value.trim()) ? path || '(값)' : null;
  }
  if (Array.isArray(value)) {
    for (const [i, v] of value.entries()) {
      const hit = findPii(v, `${path}[${i}]`);
      if (hit) return hit;
    }
    return null;
  }
  if (value && typeof value === 'object') {
    for (const [k, v] of Object.entries(value)) {
      const here = path ? `${path}.${k}` : k;
      if (splitWords(k).some(w => PII_WORDS.has(w))) return here;
      const hit = findPii(v, here);
      if (hit) return hit;
    }
  }
  return null;
}

export function checkEvent(name: string, props: Readonly<Record<string, unknown>>): RuleViolation | null {
  if (!EVENT_NAME_RE.test(name)) return 'name';
  if (findPii(props)) return 'pii';
  if (new TextEncoder().encode(JSON.stringify(props)).length > MAX_PROPS_BYTES) return 'size';
  return null;
}
